import PropTypes from 'prop-types';
import React from 'react';
import { toolLabel } from '../toolLabels';

/**
 * Lightweight "checking your sales…" line shown while a tool_call round is in
 * flight, keyed on the frozen tool names (contract §6). Replaces the v1 spinner.
 */
const ToolProgress = ({ name }) => (
  <div className="flex items-center gap-x-2 pl-1 text-xs text-grey-darker">
    <i className="kt-sparkles kai-pulse text-primary" />
    <span>{toolLabel(name)}</span>
  </div>
);

ToolProgress.propTypes = {
  name: PropTypes.string,
};

export default ToolProgress;
